export const FLAG_DOCUMENTOS_MESTRE = 'documentos.habilitado'

export const documentosCapacidadesKey = ['documentos', 'capacidades'] as const
